import firebase_app from "../configs";
import {
  OAuthProvider,
  getAdditionalUserInfo,
  getAuth,
  signInWithPopup,
} from "firebase/auth";

const provider = new OAuthProvider("yahoo.com");
const auth = getAuth(firebase_app);

export default async function signUpWithYahoo() {
  var user = null,
    error = null,
    userInfo = null,
    credential = null;
  try {
    await signInWithPopup(auth, provider)
      .then(async (result) => {
        credential = OAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        user = result.user;
        userInfo = await getAdditionalUserInfo(result);
      })
      .catch((error) => {
        // Handle Errors here.
        // const errorCode = error.code;
        // const errorMessage = error.message;
        // // The email of the user's account used.
        // const email = error.customData.email;
        // The AuthCredential type that was used.
        credential = OAuthProvider.credentialFromError(error);
      });
  } catch (error) {}
  return { user, error, userInfo, result: credential };
}
